export function convertPriceInTaxToNoTax(value: number) {
  return Math.ceil((value * 100) / 110);
}
